<script setup>
//#region import
import { ref, watch, nextTick, onBeforeMount } from 'vue';
import sortable from 'sortablejs';
//#endregion

//#region props
const props = defineProps({
  handle: {
    type: String,
    default: () => '',
  },
  animate: {
    type: Number,
    default: () => 100,
  },
});
//#endregion

//#region emits
const emit = defineEmits(['drop', 'drag']);
//#endregion

//#region data
const sortableElTableRef = ref();
const tableKey = ref(0);
const datatableRef = ref(null);
//#endregion

//#region watch
watch(() => tableKey.value, async(newValue, oldValue) => {
  await nextTick();
  makeTableSortAble();
  keepWrapperHeight(false);
});
//#endregion

//#region methods
const makeTableSortAble = () => {
  const table = datatableRef.value?.$el?.querySelector(
    '.el-table__body-wrapper tbody',
  );
  sortable.create(table, {
    handle: props.handle,
    animation: props.animate,
    onStart: () => {
      emit('drag');
    },
    onEnd: ({ newIndex, oldIndex }) => {
      keepWrapperHeight(true);
      tableKey.value = Math.random();
      const arr = datatableRef.value.data;
      const targetRow = arr.splice(oldIndex, 1)[0];
      arr.splice(newIndex, 0, targetRow);
      emit('drop', { targetObject: targetRow, list: arr });
    },
  });
};
const keepWrapperHeight = (keep) => {
  if (keep) {
    datatableRef.value.style.minHeight = `${datatableRef.value.clientHeight}px`;
  } else {
    datatableRef.value.style.minHeight = 'auto';
  }
};
const setSlotRef = (el) => {
  datatableRef.value = el;
};
//#endregion

//#region lifecycle
onBeforeMount(async() => {
  await nextTick();
  makeTableSortAble();
});
//#endregion
</script>

<template>
  <div
    ref="sortableElTableRef"
    class="sortable-el-table"
  >
    <div
      :key="tableKey"
      class="sortable-el-table__wrapper"
    >
      <slot :set-ref="setSlotRef" />
    </div>
  </div>
</template>

<style lang="scss">
.sortable-el-table {
  height: 100%;
  &__wrapper {
    height: 100%;
  }
  .el-table {
    height: 100%;
  }
}
</style>
